import { render } from "./InviteAcceptModal.vue?vue&type=template&id=9458ef04&scoped=true"
import script from "./InviteAcceptModal.vue?vue&type=script&lang=js"
export * from "./InviteAcceptModal.vue?vue&type=script&lang=js"

import "./InviteAcceptModal.vue?vue&type=style&index=0&id=9458ef04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9458ef04"]])

export default __exports__